import type { CSSProperties } from "react";
import { cn } from "../../lib/utils";

export interface FadingDividerProps {
  orientation?: "horizontal" | "vertical";
  inset?: number | string;
  className?: string;
}

export function FadingDivider({
  orientation = "horizontal",
  inset = 0,
  className,
}: FadingDividerProps) {
  const insetValue = typeof inset === "number" ? `${inset}px` : inset;
  return (
    <span
      role="separator"
      aria-orientation={orientation}
      className={cn("fintheon-fading-divider", className)}
      data-orientation={orientation}
      style={{ "--fintheon-divider-inset": insetValue } as CSSProperties}
    />
  );
}
